export default "__VITE_ASSET__BHPe_Pie__"